export default __webpack_public_path__ + "static/media/teamsIcon.48cdc0b6.svg";